import { createContext } from 'react';

/** The element `PortalLayout` keeps beside the scrolling page body, for `PortalSidePanel`. */
export const PortalSidePanelSlot = createContext<HTMLElement | null>(null);
